import { MutableRefObject, useRef } from 'react'
import { Color, rgbToHex, weightedMeanColor } from './diagram/color.ts'
import { Link } from './diagram/diagram.ts'

export type DiagramLinkProps = {
    id: string,
    height: number,
    width: number,
    link: Link,
    x: number,
    y: number,
    opacity: number | string,
    valueProportion: number,
    onClick: (link: Link) => void,
    onMouseOver: (link: Link) => void,
    onMouseLeave: () => void,
    colorFrom: Color,
    colorTo: Color
}
export const DiagramLinkLabelCompact =
    ({
        id,
        width,
        height,
        link,
        x,
        y,
        opacity,
        onClick,
        onMouseOver,
        onMouseLeave,
        colorTo,
        colorFrom,
        valueProportion
    }: DiagramLinkProps) => {
        const svgRef = useRef() as MutableRefObject<SVGSVGElement>

        const color = weightedMeanColor(colorFrom, 1 - valueProportion, colorTo, valueProportion)
        const hexColor = rgbToHex(color)

        return <svg
            id={id}
            x={x}
            y={y}
            onClick={() => onClick(link)}
            onMouseOver={() => onMouseOver(link)}
            onMouseLeave={onMouseLeave}
            height={height + 'px'}
            width={width + 'px'}
            overflow='visible'
            opacity={opacity}
            style={{ transform: 'translate(-50% -50%)' }}
            ref={svgRef}
        >
            <circle
                cx="3" cy="3" r="3"
                stroke={hexColor}
                fill='white'
                style={{
                    filter: 'drop-shadow( 0px 1px 2px rgba(0, 0, 0, .3))',
                    strokeWidth: '5%',
                    borderRadius: '50px'
                }}
                strokeLinecap='butt'
                strokeLinejoin='bevel'
            >
            </circle>
        </svg>
    }
